const $ = jQuery;
var page = 1;

$(document).ready(function () {
    $(".hamburger").click(function () {
        $(this).toggleClass("is-active");
        if ($(this).hasClass('is-active')) {
            $('body').addClass('remove-scroll');
        } else {
            $('body').removeClass('remove-scroll');
        }
    });

    $('body').on('click', '.accordion-trigger', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).find('.accordion-outer').css('height', '0px');
        } else {
            if (!$(this).closest('.accessibility-guide-page').length) {
                const active = $('.accordion-trigger.active');
                active.removeClass('active');
                active.find('.accordion-outer').css('height', '0px');
            }

            $(this).addClass('active');
            let height = $(this).find('.accordion-inner').outerHeight();
            $(this).find('.accordion-outer').css('height', height + 'px');
        }
    });

    $('.menu-btn').click(function () {
        let nav = $('header nav');
        if ($(this).find('.hamburger').hasClass('is-active')) {
            nav.addClass('active');
        } else {
            nav.removeClass('active');
        }
    });

    $('.nav-inner .parent-item').click(function (e) {
        const megaMenuBox = $(this).find('.header-megamenu');
        const target = $(e.target);

        if (target.closest('.mobile-menu-close-btn').length) {
            megaMenuBox.removeClass('active');
        } else {
            megaMenuBox.addClass('active');
        }
    });

    $('.megamenu-container .sub-menu-arrow-btn').on('mouseenter', function () {
        showSubMenu($(this));
    });

    $('.megamenu-container .sub-menu-arrow-btn').on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).closest('.megamenu-pages-col').find('#sub-menu-col').removeClass('active');
        } else {
            showSubMenu($(this));
        }
    });

    $('.nav-inner .parent-item').on('mouseenter', function () {
        $('.megamenu-container .sub-menu-arrow-btn.active').removeClass('active');
        $('.megamenu-pages-col #sub-menu-col.active').removeClass('active');
    });

    const showSubMenu = (btn) => {
        const links = btn.data('links');
        const subMenu = btn.closest('.megamenu-pages-col').find('#sub-menu-col');
        $('.megamenu-container .sub-menu-arrow-btn.active').removeClass('active');
        btn.addClass('active');

        if (links.toString() !== subMenu.data("last-list")) {
            subMenu.attr('data-last-list', links.toString());
            const list = subMenu.find('.menu-items-list');
            let newHTML = "";
            links.forEach((elm) => {
                newHTML += `<li>
                <a href="${elm.url}">${elm.title}</a>                
                </li>`;
            });
            list.html(newHTML);
            subMenu.addClass('active');
        }
    }

    $(window).scroll(function () {
        if ($(document).scrollTop() > 100) {
            $('body').addClass('scroll');
        } else {
            $('body').removeClass('scroll');
        }
    });

    $('#newsletter-form').on('submit', function (event) {
        event.preventDefault();
        var data = {
            'action': 'add_mailchimp',
            'name': $('#newsletter-form input[name="name"]').val(),
            'email': $('#newsletter-form input[name="email"]').val()
        };

        $.ajax({
            type: 'POST',
            url: window.location.origin + "/wp-admin/admin-ajax.php",
            data: data,
        }).done(function (data) {
            console.log(data);
            $('.success-text').text('Thank you for subscribing to our newsletter!');
            $('#newsletter-form').trigger("reset");
        });
    });
    // Home Pop Up Mail Chimp API Call
    $('#popup-newletter').on('submit', function (event) {
        event.preventDefault();
        var data = {
            'action': 'add_mailchimp',
            'name': $('#popup-newletter input[name="name"]').val(),
            'email': $('#popup-newletter input[name="email"]').val()
        };

        $.ajax({
            type: 'POST',
            url: window.location.origin + "/wp-admin/admin-ajax.php",
            data: data,
        }).done(function (data) {
            console.log(data);
            $('.home .success-text').text('Thank you for subscribing to our newsletter!');
            $('#popup-newletter').trigger("reset");
        });
    });

    $('.faq-page .select-btn').on('click', function () {
        $('.faq-page .select-btn').each(function () {
            $(this).removeClass('active');
        });
        $(this).addClass('active');

        let data = {
            'action': 'load_faq',
            'id': $(this).attr("data-id")
        };

        $(".faq-results").html(`<div class="text-center"><img src="${script_vars.templateDir}/assets/images/gifs/red-loading.gif" alt="Loading"></div>`);

        $.ajax({
            type: 'POST',
            url: window.location.origin + "/wp-admin/admin-ajax.php",
            data: data,
        }).done(function (data) {
            $(".faq-results").html(data);
        });
    });

    // Filter Vendor Show / Hide (Mobile)
    $('.vendor-filter-mobile-btn button').on('click', function () {
        $('.vendor-filter-part').toggle();
        $('.et-filter-part').toggle();
        $(this).toggleClass('active');
    })

    // Vendors Page functions
    let page = 1;
    const AJAX_URL = window.location.origin + "/wp-admin/admin-ajax.php";
    const sourcePageId = $('.vendors-page').data('source-id') || 0; // NEW

    // Search
    $('.vendors-page input[name="vendor-search"]').on('keyup', function () {
        page = 1; // reset
        let search = $(this).val().trim();
        let typeFilters = [];
        let foodFilters = [];

        if (!$('.vendors-page .all-btn').hasClass('active')) {
            $('.vendors-page .select-btn.active').each(function () {
                typeFilters.push($(this).attr("data-id"));
            });
            $('.vendors-page .vendor-food-btn.active').each(function () {
                foodFilters.push($(this).attr("data-id"));
            });
        }

        let data = {
            action: 'filter_vendor',
            type_filters: typeFilters,
            food_filters: foodFilters,
            search: search,
            page: page,
            quote_index: 0, // reset quotes on search
            rendered_count: 0, // reset total on search
            source_page_id: sourcePageId // NEW
        };

        $(".vendor-results").html(
            `<div class="full-loading-cell text-center col-12">
            <img src="${script_vars.templateDir}/assets/images/gifs/red-loading.gif" alt="Loading">
            </div>`
        );

        $.ajax({
            type: 'POST',
            url: AJAX_URL,
            data: data,
        }).done(function (markup) {
            $(".vendor-results").html(markup);
            $container.masonry('destroy');
            $container = $('.vendor-results').masonry({
                columnWidth: '.masonry-grid-item',
                itemSelector: '.masonry-grid-item',
                percentPosition: true,
                isFitWidth: false
            });
            setTimeout(function () { $container.masonry('layout'); }, 500);
        });
    });

    // Filters
    var $container = $('.vendor-results').masonry({
        itemSelector: '.masonry-grid-item',
        isFitWidth: false,
        percentPosition: true,
        columnWidth: '.masonry-grid-item'
    });

    // NEW: also listen for videos
    $container.find('video').each(function () {
        this.addEventListener('loadedmetadata', function () {
            $container.masonry('layout');
        });
    });

    $('.vendors-page .select-btn, .vendors-page .vendor-food-btn').on('click', function () {
        page = 1;

        let typeFilters = [];
        let foodFilters = [];
        $('.vendor-input-wrapper input').val(''); // clear search

        if ($(this).hasClass('all-btn')) {
            $('.vendors-page .vendor-food-btn, .vendors-page .select-btn').each(function () {
                $(this).removeClass('active');
            });
            $('.vendors-page .all-btn').addClass('active');
        } else {
            $('.vendors-page .all-btn').removeClass('active');
            $(this).toggleClass('active');
            $('.vendors-page .select-btn.active').each(function () { typeFilters.push($(this).attr("data-id")); });
            $('.vendors-page .vendor-food-btn.active').each(function () { foodFilters.push($(this).attr("data-id")); });
        }

        let data = {
            action: 'filter_vendor',
            type_filters: typeFilters,
            food_filters: foodFilters,
            page: page,
            quote_index: 0, // reset on filter
            rendered_count: 0, // reset on filter
            source_page_id: sourcePageId // NEW
        };

        $(".vendor-results").html(
            `<div class="full-loading-cell text-center col-12">
            <img src="${script_vars.templateDir}/assets/images/gifs/red-loading.gif" alt="Loading">
            </div>`
        );

        $.ajax({
            type: 'POST',
            url: AJAX_URL,
            data: data,
        }).done(function (markup) {
            $(".vendor-results").html(markup);
            $container.masonry('destroy');
            $container = $('.vendor-results').masonry({
                itemSelector: '.masonry-grid-item',
                isFitWidth: false,
                percentPosition: true,
                columnWidth: '.masonry-grid-item'
            });
            setTimeout(function () { $container.masonry('layout'); }, 500);
        });
    });

    if ($('.vendors-page .select-btn').length) {
        const urlParams = new URLSearchParams(window.location.search);
        if (type = urlParams.get('type')) {
            let separator = type.indexOf(',') > -1 ? "," : type.indexOf('%2c') > -1 ? "%2c" : "";
            if (separator) {
                const typeArr = type.split(separator);
                console.log(typeArr);
                typeArr.forEach((text) => $('.vendors-page').find(`.select-btn[data-type='${text}']`).trigger('click'));
            } else {
                $('.vendors-page').find(`.select-btn[data-type='${type}']`).trigger('click');
            }
        }
    }

    // Sort dropdown
    $('#vendor-sort').on('change', function () {
        page = 1; // reset
        let sort = $(this).val();
        let typeFilters = [];
        let foodFilters = [];
        let search = $('.vendor-input-wrapper input').val().trim();

        if (!$('.vendors-page .all-btn').hasClass('active')) {
            $('.vendors-page .select-btn.active').each(function () {
                typeFilters.push($(this).attr("data-id"));
            });
            $('.vendors-page .vendor-food-btn.active').each(function () {
                foodFilters.push($(this).attr("data-id"));
            });
        }

        let data = {
            action: 'filter_vendor',
            type_filters: typeFilters,
            food_filters: foodFilters,
            search: search,
            page: page,
            quote_index: 0,
            rendered_count: 0,
            source_page_id: sourcePageId,
            sort: sort
        };

        $(".vendor-results").html(
            `<div class="full-loading-cell text-center col-12">
            <img src="${script_vars.templateDir}/assets/images/gifs/red-loading.gif" alt="Loading">
            </div>`
        );

        $.ajax({
            type: 'POST',
            url: AJAX_URL,
            data: data,
        }).done(function (markup) {
            $(".vendor-results").html(markup);
            $container.masonry('destroy');
            $container = $('.vendor-results').masonry({
                itemSelector: '.masonry-grid-item',
                isFitWidth: false,
                percentPosition: true,
                columnWidth: '.masonry-grid-item'
            });
            setTimeout(function () { $container.masonry('layout'); }, 500);
        });
    });

    // Load More
    $('.vendors-page').on('click', '.vendor-load-more', function (e) {
        e.preventDefault();

        page = page + 1;
        let typeFilters = [];
        let foodFilters = [];

        let nextQuoteIndex = $(this).attr('data-next-quote-index')
            ? parseInt($(this).attr('data-next-quote-index'), 10)
            : 0;

        let renderedCount = $(this).attr('data-rendered-count')
            ? parseInt($(this).attr('data-rendered-count'), 10)
            : 0;

        // 👇 NEW: get sort from button dataset (set in PHP)
        let sort = $(this).attr('data-sort') || $('#vendor-sort').val() || 'latest';

        if (!$('.vendors-page .all-btn').hasClass('active')) {
            $('.vendors-page .select-btn.active').each(function () {
                typeFilters.push($(this).attr("data-id"));
            });
            $('.vendors-page .vendor-food-btn.active').each(function () {
                foodFilters.push($(this).attr("data-id"));
            });
        }

        let data = {
            action: 'filter_vendor',
            type_filters: typeFilters,
            food_filters: foodFilters,
            page: page,
            quote_index: nextQuoteIndex,
            rendered_count: renderedCount,
            source_page_id: sourcePageId,
            sort: sort // 👈 IMPORTANT
        };

        $(".vendors-page .load-more-content").html(
            `<img src="${script_vars.templateDir}/assets/images/gifs/red-loading.gif" alt="Loading">`
        );

        $.ajax({
            type: 'POST',
            url: AJAX_URL,
            data: data,
        }).done(function (markup) {
            let $items = $(markup);
            $('.vendors-page .load-more-content').remove();
            $('.vendor-results').append($items);
            // Masonry refresh
            $container.masonry('appended', $items);
            if (typeof $container.imagesLoaded === "function") {
                $container.imagesLoaded().progress(function () {
                    $container.masonry('layout');
                });
            } else {
                setTimeout(function () { $container.masonry('layout'); }, 500);
            }
        });
    });

    $('.main-slide-for').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        asNavFor: '.vendor-image-slider'
    });
    $('.vendor-image-slider').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: '.main-slide-for',
        prevArrow: '<i class="slick-prev fa-solid fa-caret-left"></i>',
        nextArrow: '<i class="slick-next fa-solid fa-caret-right"></i>',
        focusOnSelect: true
    });

    $('.vendor-image-slider').on('click', 'img', function () {
        const newSrc = $(this).attr('src');
        $('.vendor-image').attr('src', newSrc);
    });

    $('.activities-slider').slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        dots: false,
        adaptiveHeight: true,
        prevArrow: '<i class="slick-prev fa-solid fa-caret-left"></i>',
        nextArrow: '<i class="slick-next fa-solid fa-caret-right"></i>',
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
        ]
    });

    // Filter Vendors Through URL Params
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has('filter')) {
        const id = urlParams.get('filter');
        $(`.vendors-page .select-btn[data-id='${id}']`).trigger("click");
    }
    // Filter Vendors Through URL Params

    const popup = getCookie('home-popup');
    if (!popup) {
        setCookie('home-popup', 1, 7);
        setTimeout(() => { $('.home-popup').addClass('active'); }, 3000);
    }

    $('.home-popup').on('click', function () {
        $('.home-popup-bg').removeClass('active');
    });

    $(".home-popup").click(function (e) {
        if (!($(e.target).hasClass('popup-content')) && !($(e.target).parents(".popup-content").length)) {
            $('.home-popup').removeClass('active');
        }
    });

    $('.close-btn').on('click', function () {
        $('.home-popup').removeClass('active');
    });


    $('#popup-newletter').on('submit', function (event) {
        event.preventDefault();
    });


    $('body').on('click', '.buy-btn', function () {
        'use strict'
        !(function (a, e) {
            if (!a.aap) {
                a.aap = function (e) {
                    ; (a.acuityAdsEventQueue = a.acuityAdsEventQueue || []).push(e)
                }
                var t = 'script'
                var i = e.createElement(t)
                i.async = true
                i.src = 'https://origin.acuityplatform.com/event/v2/pixel.js'
                var c = e.getElementsByTagName(t)[0]
                c.parentNode.insertBefore(i, c)
                a.acuityPiggybackCallback = function (e) {
                    a.acuityParseResponse(e)
                }
            }
        })(window, document)
        aap({ pixelKey: '1529473886844603129', pg: 32373 })
    });


    if ($('.review-page').length) {
        const parent = $('.review-page');
        parent.on('click', '.rating-select span', function () {
            const value = $(this).attr('data-value');
            parent.find('.rating-select span.active').removeClass('active');
            $(this).addClass('active');
            parent.find('#rating-value').val(value);
        });

        parent.on('submit', '#rating-form', function (event) {
            event.preventDefault();

            const highLink = $(this).data('high-link');
            const lowLink = $(this).data('low-link');
            const breakpoint = $(this).data('breakpoint');
            const value = parent.find('#rating-value').val();

            if (value >= breakpoint) {
                window.open(highLink, '_blank').focus();
            } else {
                window.open(lowLink, '_blank').focus();
            }

        });
    }

    // Plan your Visit
    $(".services-layout-section").hide();
    function activateTab(tabId) {
        $('.services-layout-section').hide();
        $('.services-item').removeClass('active');
        $(tabId).fadeIn();

        // Find related button and activate it
        var index = tabId.replace('#PlanYourVisit', '');
        $('.services-item[target="' + index + '"]').addClass('active');

        // Scroll to wrapper with header offset
        var headerHeight = $('.site-header').outerHeight() || 0;
        var targetOffset = $('.services-section-wrapper').offset().top - headerHeight;
        $('html, body').animate({
            scrollTop: targetOffset
        }, 600);
    }

    // On click event
    $('.services-item').click(function (e) {
        e.preventDefault();
        var tabId = '#PlanYourVisit' + $(this).attr('target');
        window.location.hash = tabId; // update URL hash
        activateTab(tabId);
    });
    // On page load, check if hash exists
    if (window.location.hash) {
        var tabId = window.location.hash;
        if ($(tabId).length) {
            activateTab(tabId);
        }
    }
    // Same page handle hash without reload
    $(window).on('hashchange', function () {
        var tabId = window.location.hash;
        if ($(tabId).length) {
            activateTab(tabId);
        }
    });

    // FAQ Accordion
    $('.accessibility-body').hide();
    $('.accessibility-header').click(function () {
        var $body = $(this).next('.accessibility-body');
        // Toggle current
        $body.slideToggle();
        // (Optional) Close others
        $('.accessibility-body').not($body).slideUp();
    });

    // FAQ Accordion ~ TAB
    $(".faqTabSection").hide();
    $(".faqTabSection:first").show();
    $(".faq-chip-tab .theme-btn:first").addClass("active");
    $(".faq-chip-tab .theme-btn").click(function (e) {
        e.preventDefault();
        var headerHeight = $(".site-header").outerHeight() || 0;
        var targetID = $(this).attr("href");
        // Hide all and show the clicked one
        $(".faqTabSection").hide();
        $(targetID).fadeIn();
        // Active class handling
        $(".faq-chip-tab .theme-btn").removeClass("active");
        $(this).addClass("active");
        // Smooth scroll
        if ($(targetID).length) {
            var targetTabSectionOffset = $(targetID).offset().top - headerHeight;
            $("html, body").animate(
                {
                    scrollTop: targetTabSectionOffset,
                },
                600
            );
        }
    });

    // Event Slider
    const eventMagicSlider = $('.magic-slider-section');

    eventMagicSlider.on('click', '.arrow-prev, .arrow-next, .slide-wrapper.before, .slide-wrapper.after',
        function (event) {
            event.preventDefault();

            if (!eventMagicSlider.hasClass('disabled')) {
                eventMagicSlider.find('.slide-wrapper.active').removeClass('show-text');

                const isPrev = $(this).hasClass('arrow-prev') || $(this).hasClass('before');
                if (!isPrev) {
                    if (!eventMagicSlider.hasClass('pressed')) {
                        eventMagicSlider.find('.slide-wrapper:last-child').remove();
                    }

                    eventMagicSlider.find('.slide-wrapper.next').each(function () {
                        $(this).removeClass('onLeft');
                        $(this).addClass('onRight');
                    });

                    const beforeEl = eventMagicSlider.find('.slide-wrapper.before');
                    beforeEl.removeClass('before');
                    beforeEl.addClass('next onLeft');

                    const activeEl = eventMagicSlider.find('.slide-wrapper.active');
                    activeEl.removeClass('active');
                    activeEl.addClass('before');

                    const afterEl = eventMagicSlider.find('.slide-wrapper.after');
                    afterEl.removeClass('after');
                    afterEl.addClass('active');

                    const nextEl = afterEl.next().length
                        ? afterEl.next() : eventMagicSlider.find('.slide-wrapper:first-child');
                    nextEl.removeClass('next onRight');
                    nextEl.addClass('after');
                } else {
                    if (!eventMagicSlider.hasClass('pressed')) {
                        eventMagicSlider.find('.slide-wrapper:nth-last-child(2)').remove();
                    }

                    eventMagicSlider.find('.slide-wrapper.next').each(function () {
                        $(this).removeClass('onRight');
                        $(this).addClass('onLeft');
                    });

                    const afterEl = eventMagicSlider.find('.slide-wrapper.after');
                    afterEl.removeClass('after');
                    afterEl.addClass('next onRight');

                    const activeEl = eventMagicSlider.find('.slide-wrapper.active');
                    activeEl.removeClass('active');
                    activeEl.addClass('after');

                    const beforeEl = eventMagicSlider.find('.slide-wrapper.before');
                    beforeEl.removeClass('before');
                    beforeEl.addClass('active');

                    const prevEl = beforeEl.prev().length
                        ? beforeEl.prev() : eventMagicSlider.find('.slide-wrapper:last-child');
                    prevEl.removeClass('next onLeft');
                    prevEl.addClass('before');
                }

                eventMagicSlider.addClass('pressed disabled');
                setTimeout(() => {
                    eventMagicSlider.find('.slide-wrapper.active').addClass('show-text');
                    eventMagicSlider.removeClass('disabled');
                }, 300);
            }
        });

    // Experience Page
    const mainBase = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
        fade: true,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 4000
    };
    const navBase = {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        focusOnSelect: true
    };

    // --- Helper: init sliders for a specific tab (scoped) ---
    function initTab($tab) {
        const $main = $tab.find('.christmas-slick-slider');
        const $nav = $tab.find('.slider-event-nav');
        const $textLinks = $tab.find('.christmas-slider-text a[data-slide]');

        // Guard: avoid double init
        if ($main.hasClass('slick-initialized')) $main.slick('unslick');
        if ($nav.hasClass('slick-initialized')) $nav.slick('unslick');

        // Init pair (scope asNavFor by element not selector)
        $main.slick({ ...mainBase, asNavFor: $nav });
        $nav.slick({ ...navBase, asNavFor: $main });

        // Sync text links on init and after every change
        // Remove any previous namespaced listeners, then bind
        $main.off('init.sync afterChange.sync')
            .on('init.sync afterChange.sync', function (event, slick, currentSlide) {
                // On 'init', Slick passes currentSlide as undefined; use slick.currentSlide
                const idx = typeof currentSlide === 'number' ? currentSlide : (slick.currentSlide || 0);
                $textLinks.removeClass('active');
                $textLinks.filter('[data-slide="' + (idx + 1) + '"]').addClass('active');
            });

        // Manually trigger 'init' sync once Slick finishes initializing
        // (Slick fires 'init' before this handler attaches if we call .slick() first)
        const currentIdx = $main.slick('slickCurrentSlide') || 0;
        $textLinks.removeClass('active');
        $textLinks.filter('[data-slide="' + (currentIdx + 1) + '"]').addClass('active');
    }

    // --- Initial tab setup ---
    const $tabs = $('.christmas-tab-body');
    $tabs.hide();

    const $firstTab = $tabs.first().show();
    initTab($firstTab);

    $('.christmas-slider-text a:first-child').addClass('active');
    $('.tab-area a:first-child').addClass('active');
    $('.event-slider-cta').on('click', function () {
        const targetId = '#christmasTab' + $(this).attr('target');
        const $targetTab = $(targetId);
        // UI state
        $tabs.hide();
        $('.event-slider-cta').removeClass('active');
        $(this).addClass('active');

        // Reset text link actives only inside the target tab; init will set the correct one
        $tabs.find('.christmas-slider-text a').removeClass('active');

        // Show + init only the target tab
        $targetTab.show();
        initTab($targetTab);
    });

    // --- Text links -> go to slide (scoped to the visible tab only) ---
    $('.christmas-slider-text').on('click', 'a[data-slide]', function (e) {
        e.preventDefault();
        const slideno = (Number($(this).data('slide')) || 1) - 1;
        const $visibleTab = $('.christmas-tab-body:visible');
        const $main = $visibleTab.find('.christmas-slick-slider.slick-initialized');
        // Update active state only inside the visible tab
        $visibleTab.find('.christmas-slider-text a').removeClass('active');
        $(this).addClass('active');
        if ($main.length) {
            $main.slick('slickGoTo', slideno, true);
        }
    });

    // Add Class in Header Experience Page
    if ($('body').hasClass('page-template-experience-page') || $('body').hasClass('page-template-new-home-page')) {
        $('header.site-header').removeClass('red-bg');
        $(window).on('scroll', function () {
            if ($(this).scrollTop() >= 80) {
                $('header.site-header').addClass('red-bg');
            } else {
                $('header.site-header').removeClass('red-bg');
            }
        });
    }

    // Video AutoPlay & Mute functionality
    var video = $("#homeVideo")[0];
    if (video) {
        video.muted = true;
        video.play().catch(function (error) {
            console.log('Autoplay was prevented:', error);
        });

        $(".mute-on-off-btn").on("click", function () {
            video.muted = !video.muted;
            $(this).toggleClass("off");
        });
    }

    // Home Testimonial Slider
    var $homeSliderTestimonial = $('.HomeTestimonialSlider');
    $homeSliderTestimonial.slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: false,
        pauseOnFocus: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
    });
    $('.slider-arrows .prev').on('click', function () {
        $homeSliderTestimonial.slick('slickPrev');
    });
    $('.slider-arrows .next').on('click', function () {
        $homeSliderTestimonial.slick('slickNext');
    });

    // Home Testimonial Slider
    var $homeSliderWorkShop = $('.home-workshop-slider');
    $homeSliderWorkShop.slick({
        infinite: true,
        autoplay: false,
        fade: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        pauseOnFocus: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
    });
    $('.workshop-arrow.prev').on('click', function () {
        $homeSliderWorkShop.slick('slickPrev');
    });
    $('.workshop-arrow.next').on('click', function () {
        $homeSliderWorkShop.slick('slickNext');
    });

    // EATS & TREATS — AJAX search, tabs filter, load more 
    let etPage = 1;
    const ET_AJAX_URL = window.location.origin + "/wp-admin/admin-ajax.php";
    // helper
    function currentTypeFilters() {
        const ids = [];
        if (!$('.eats-treats-section .all-btn').hasClass('active')) {
            $('.eats-treats-section .select-btn.active').each(function () {
                const id = $(this).attr('data-id');
                if (id) ids.push(id);
            });
        }
        return ids;
    }

    function currentSearch() {
        return $('.eats-treats-section input[name="et-search"]').val()?.trim() || '';
    }

    function renderLoading(targetSel) {
        $(targetSel).html(
            `<div class="full-loading-cell text-center col-12">
            <img src="${script_vars.templateDir}/assets/images/gifs/red-loading.gif" alt="Loading">
        </div>`
        );
    }

    function fetchAndRender(opts, { replace = true } = {}) {
        const data = Object.assign({
            action: 'filter_eats_treats',
            page: etPage
        }, opts);

        if (replace) {
            renderLoading(".eats-treats-post-listing .et-card-row");
        } else {
            $(".eats-treats-post-listing .load-more-content").html(
                `<div class="text-center"><img src="${script_vars.templateDir}/assets/images/gifs/red-loading.gif" alt="Loading"></div>`
            );
        }

        $.ajax({
            type: 'POST',
            url: ET_AJAX_URL,
            data
        }).done(function (markup) {
            if (replace) {
                $(".eats-treats-post-listing .et-card-row").html(markup);
            } else {
                $(".eats-treats-post-listing .load-more-content").remove();
                $(".eats-treats-post-listing .et-card-row").append(markup);
            }
        });
    }

    // Search (keyup)
    $('.eats-treats-section input[name="et-search"]').on('keyup', function () {
        etPage = 1;
        const typeFilters = currentTypeFilters();
        const search = currentSearch();
        const sort = $('#et-sort').val() || 'latest';

        fetchAndRender({ type_filters: typeFilters, search, sort }, { replace: true });
    });

    // Tabs filter (only categories)
    $('.eats-treats-section .select-btn').on('click', function () {
        etPage = 1;
        // clear search when clicking filters
        $('.eats-treats-section .et-input-wrapper input').val('');

        if ($(this).hasClass('all-btn')) {
            $('.eats-treats-section .select-btn').removeClass('active');
            $(this).addClass('active');
        } else {
            $('.eats-treats-section .all-btn').removeClass('active');
            $(this).toggleClass('active');
            // If none selected, fall back to All
            if ($('.eats-treats-section .select-btn.active').not('.all-btn').length === 0) {
                $('.eats-treats-section .all-btn').addClass('active');
            }
        }

        const typeFilters = currentTypeFilters();
        const sort = $('#et-sort').val() || 'latest';

        fetchAndRender({ type_filters: typeFilters, sort }, { replace: true });
    });

    // Sort select change
    $('.eats-treats-section #et-sort').on('change', function () {
        etPage = 1;
        const typeFilters = currentTypeFilters();
        const search = currentSearch();
        const sort = $(this).val();

        fetchAndRender({ type_filters: typeFilters, search, sort }, { replace: true });
    });

    // Support URL param ?type=Name or ?type=A,B
    if ($('.eats-treats-section .select-btn').length) {
        const urlParams = new URLSearchParams(window.location.search);
        let type = urlParams.get('type');
        if (type) {
            const sep = type.includes(',') ? ',' : (type.includes('%2c') ? '%2c' : '');
            if (sep) {
                type.split(sep).forEach((text) => {
                    $('.eats-treats-section').find(`.select-btn[data-type='${decodeURIComponent(text)}']`).trigger('click');
                });
            } else {
                $('.eats-treats-section').find(`.select-btn[data-type='${decodeURIComponent(type)}']`).trigger('click');
            }
        }
    }

    // Load more
    $('.eats-treats-section').on('click', '.et-load-more', function () {
        etPage = etPage + 1;
        const typeFilters = currentTypeFilters();
        const search = currentSearch();
        const sort = $('#et-sort').val(); // current sort
        fetchAndRender({ type_filters: typeFilters, search, sort }, { replace: false });
    });


    // Same width button on home page
    var btnMaxWidth = 0;
    $('.home-market-cards-section .cta-btn-group .theme-btn-g').each(function () {
        var thisWidth = $(this).outerWidth();
        if (thisWidth > btnMaxWidth) {
            btnMaxWidth = thisWidth;
        }
    });
    $('.home-market-cards-section .cta-btn-group .theme-btn-g').css('width', btnMaxWidth + 'px');
});

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

// HOME PAGE V2 (First section Padding)
// function setHeroPadding() {
//     var headerHeight = $('header.site-header').outerHeight();
//     if (headerHeight < 100) headerHeight = 100;
//     $('.home-banner .content, .experience-video-section .inner-wrapper').css('padding-top', headerHeight + 'px');
// }
// Run on page load
// $(document).ready(function () {
//     setHeroPadding();
// });
// // Also run on window resize (in case header height changes)
// $(window).on('resize', function () {
//     setHeroPadding();
// });

// Counter Number JS
var counterNumVal = 0;
$(window).scroll(function () {
    if ($('body').hasClass('page-template-new-home-page')) {
        var counterOffsetTop = $("#counter-box").offset().top - window.innerHeight;
        if (counterNumVal == 0 && $(window).scrollTop() > counterOffsetTop) {
            $(".counter").each(function () {
                var $this = $(this), countTo = $this.attr("data-number");
                $({ countNum: $this.text() }).animate({
                    countNum: countTo
                }, {
                    duration: 3000,
                    easing: "swing",
                    step: function () {
                        $this.text(
                            Math.ceil(this.countNum).toLocaleString("en")
                        );
                    },
                    complete: function () {
                        $this.text(
                            Math.ceil(this.countNum).toLocaleString("en")
                        );
                    }
                });
            });
            counterNumVal = 1;
        }
    }
});


$(document).ready(function () {
    var $videos = $('.short-videos-area .video-block video');
    var totalVideos = $videos.length;
    var middleIndex = Math.floor(totalVideos / 2);

    // Autoplay only middle video
    $videos.each(function (index) {
        var $block = $(this).closest('.video-block');
        var $btn = $block.find('.play-push-btn');

        if (index === middleIndex) {
            this.play();  // middle autoplay
            $btn.addClass('playing'); //Add playing class on its button
        } else {
            this.pause(); // Other videos paused
            $btn.removeClass('playing'); // Ensure no playing class
        }
    });

    // Play/Pause toggle
    $('.short-videos-area').on('click', '.play-push-btn', function () {
        var $block = $(this).closest('.video-block');
        var video = $block.find('video').get(0);

        if (video.paused) {
            video.play();
            $(this).addClass('playing');
        } else {
            video.pause();
            $(this).removeClass('playing');
        }
    });

    // Sound toggle on .short-vid-btn
    $('.short-videos-area').on('click', '.short-vid-btn', function () {
        var $block = $(this).closest('.video-block');
        var video = $block.find('video').get(0);

        if ($(this).hasClass('off')) {
            video.muted = false;
            $(this).removeClass('off');
        } else {
            video.muted = true;
            $(this).addClass('off');
        }
    });
});

// Fixed Scrolling Arrow ~ Home page
$(document).ready(function () {
    let $arrow = $('.scrolling-arrow');

    if ($arrow.length) {

        let $arrowSection = $('.home-market-cards-section'); // parent section of arrow
        let $hideSection = $('.memories-video-section h2'); // section where arrow hides

        function handleArrow() {
            let scrollTop = $(window).scrollTop();
            let windowHeight = $(window).height();
            let arrowTop = $arrowSection.offset().top;
            let hideTop = $hideSection.offset().top;

            // Mobile responsive: always active on small screens
            if ($(window).width() <= 768) {
                $arrow.addClass('active');
                if (scrollTop + windowHeight >= hideTop) {
                    $arrow.addClass('hide');
                } else {
                    $arrow.removeClass('hide');
                }
                return;
            }

            // Hide arrow when reaching hide section (desktop)
            if (scrollTop + windowHeight >= hideTop) {
                $arrow.removeClass('active').addClass('hide');
                return;
            } else {
                $arrow.removeClass('hide');
            }

            // Add active only when reaching arrow section (desktop)
            if (scrollTop + windowHeight >= arrowTop) {
                $arrow.addClass('active');
            } else {
                $arrow.removeClass('active');
            }
        }

        handleArrow(); // Initial check
        $(window).on('scroll resize', handleArrow);
    }
});
